var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-layout',{scopedSlots:_vm._u([{key:"topLink",fn:function(){return [_c('v-btn',{staticClass:"text-none",attrs:{"text":"","color":"txtSecondary","to":{name: 'login'}}},[_vm._v(" "+_vm._s(_vm.$t('entrance.login'))+" ")])]},proxy:true}])},[_c('user-form',{on:{"success":_vm.onSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }